// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"a0bd13201bafa9153519","691":"b5794f3f32ec2470bc14"}[chunkId] + ".js";
};